import { useQuery } from '@tanstack/react-query';

import { PersonOrgIdentity } from '@ndvr/customer-api';

import { CustomerApi } from 'API';
import { PersonCoreData } from 'views/person/person-queries';

const identityToCoreData = (identity: PersonOrgIdentity): PersonCoreData => ({
    personOrgGUID: identity.personOrgGUID,
    personOrgType: identity.personOrgType,
    firstName: identity.firstNamePlain,
    lastName: identity.lastNamePlain,
    orgName: identity.orgNamePlain,
    email: identity.primaryEmailPlain ?? '',
});

/**
 * App users across every tenant, for feature flag overrides. The endpoint requires FEATURE_FLAG_MANAGER;
 * use the tenant-scoped person hooks everywhere else.
 */
export const useAdminPersonCoreData = () =>
    useQuery({
        queryKey: ['featureFlag', 'personIdentities'],
        queryFn: async () => {
            const [response] = await CustomerApi().getAllPersonOrgIdentitiesForAdmin();
            return response?.map(identityToCoreData) ?? [];
        },
    });
